import CompanyAvailabilityCalendarHeader from './CompanyAvailabilityCalendarHeader';

export default CompanyAvailabilityCalendarHeader;
